import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import {
	BankEmployeesModel,
	TimeOffModel,
	LoginSubstitutionType,
	SubstitutionInfoModel,
} from 'Pages/bankEmployees'

export const bankEmployeesApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BankEmployeesModel>>(
			urls.bank_employees.index,
			{
				params,
			}
		)
		return res.data
	},
	createOne: async (data: TimeOffModel) => {
		const res = await axiosDS().post<TimeOffModel>(urls.bank_employees.time_off, { data })
		return res.data
	},
	updateOne: async (id: string, data: TimeOffModel) => {
		const res = await axiosDS().patch<TimeOffModel>(`${urls.bank_employees.time_off}/${id}`, {
			data,
		})
		return res.data
	},
	getOne: async (id: string) => {
		const res = await axiosDS().get<BankEmployeesModel>(`${urls.bank_employees.index}/${id}`)
		return res.data
	},
	getSubstitutionInfo: async () => {
		const res = await axiosDS().get<SubstitutionInfoModel>(urls.bank_employees.substitution_info)
		return res.data
	},
	getLoginSubstitution: async (id: string) => {
		const res = await axiosDS().get<LoginSubstitutionType>(
			urls.bank_employees.login_substitution.replace(':id', id)
		)
		return res.data
	},
}
